export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const toPercentage = (value: number): string => {
  return Math.round(value * 100) + '%'
}
